import type { ReturnsOrder } from '@itsrever/rever-api'
import { useTranslate } from '@/hooks'
import { useTranslation } from 'react-i18next'
import { useAppSelector } from '@/redux/hooks'

export const OrderDetails = ({
  order
}: {
  order: ReturnsOrder | undefined
}) => {
  const { translate } = useTranslate()
  const { i18n } = useTranslation()

  const group = useAppSelector(
    (store) => store.settingsApi.settings.response.ecommerce_group
  )

  const isMisako = group === 'misako'
  const isHoff = group === 'hoff'

  if (isHoff) {
    return (
      <div className="space-y-2">
        <p className="text-lg font-light text-neutral-950 [text-wrap:balance]">
          <span
            dangerouslySetInnerHTML={{
              __html: translate('item_selection_order')
            }}
          />{' '}
          {order?.identification?.customer_printed_order_id ?? '-'}
        </p>
        <p className="text-sm font-light text-neutral-950 [text-wrap:balance]">
          <span
            dangerouslySetInnerHTML={{
              __html: translate('item_selection_date')
            }}
          />{' '}
          {order?.purchased_at
            ? new Date(order.purchased_at).toLocaleDateString(i18n.language, {
                year: 'numeric',
                month: 'long',
                day: 'numeric'
              })
            : '-'}
        </p>
      </div>
    )
  }

  if (isMisako) {
    return (
      <div className="space-y-1">
        <p className="text-sm font-light uppercase tracking-wide text-neutral-700 [text-wrap:balance]">
          <span
            dangerouslySetInnerHTML={{
              __html: translate('item_selection_order')
            }}
          />{' '}
          {order?.identification?.customer_printed_order_id ?? '-'}
        </p>
        <p className="text-xs font-light uppercase tracking-wide text-neutral-700 [text-wrap:balance]">
          <span
            dangerouslySetInnerHTML={{
              __html: translate('item_selection_date')
            }}
          />{' '}
          {order?.purchased_at
            ? new Date(order.purchased_at).toLocaleDateString(i18n.language, {
                year: 'numeric',
                month: 'long',
                day: 'numeric'
              })
            : '-'}
        </p>
      </div>
    )
  }

  return (
    <div className="flex flex-wrap items-center justify-between gap-1.5">
      <div className="rounded-lg bg-neutral-200 px-2.5 py-1">
        <p className="text-xs font-normal text-neutral-950 [text-wrap:balance]">
          <span
            className="text-neutral-600"
            dangerouslySetInnerHTML={{
              __html: translate('item_selection_order')
            }}
          />{' '}
          {order?.identification?.customer_printed_order_id ?? '-'}
        </p>
      </div>
      <div className="rounded-lg bg-neutral-200 px-2.5 py-1">
        <p className="text-xs font-normal text-neutral-950 [text-wrap:balance]">
          <span
            className="text-neutral-600"
            dangerouslySetInnerHTML={{
              __html: translate('item_selection_date')
            }}
          />{' '}
          {order?.purchased_at
            ? new Date(order.purchased_at).toLocaleDateString(i18n.language, {
                year: 'numeric',
                month: 'long',
                day: 'numeric'
              })
            : '-'}
        </p>
      </div>
    </div>
  )
}
